import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "@/lib/site";

/** Always-visible call and WhatsApp bar on phones. */
const MobileCallBar = () => (
  <>
    <div className="h-16 lg:hidden" aria-hidden />
    <nav aria-label="Contact us" className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-border bg-background p-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] lg:hidden">
      <a href={PHONE_TEL} className="inline-flex items-center justify-center gap-2 rounded-full bg-primary py-3 font-semibold text-primary-foreground">
        <Phone className="h-5 w-5" aria-hidden /> Call us
      </a>
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-primary py-3 font-semibold text-primary">
        <MessageCircle className="h-5 w-5" aria-hidden /> WhatsApp
      </a>
    </nav>
  </>
);

export default MobileCallBar;
